import { SqliteRevisionedRepository } from "./sqlite-revisioned-repository.js";
export class SqliteGraphRepository extends SqliteRevisionedRepository {
    constructor(database, options = {}) {
        super(database, { ...options, domain: "graph" });
    }
}
//# sourceMappingURL=graph-repository.js.map